import cn from 'classnames';
import { ReactComponent as SolanaIcon } from '@assets/svg/solana.svg';
import { ReactComponent as CoinIcon } from '@assets/svg/coin.svg';
import { ReactComponent as SolanaNoBgIcon } from '@assets/svg/solana-no-background.svg';
import { ChangeEvent, useEffect, useState } from 'react';
import Input from './Input';
import Button from '@components/button';
import useReduxState from '@hooks/useReduxState';
import styles from './common.module.scss';

import readyAudio from '@assets/audio/ready.mp3';
import errorAudio from '@assets/audio/error.mp3';
import useSound from 'use-sound';

import { convertSOLtoDuelanaPoints, toastErrorMessage, toastSuccessMessage } from '@utils/utils';
import { Connection, LAMPORTS_PER_SOL, PublicKey, SystemProgram, Transaction } from '@solana/web3.js';
import { ConnectWallet } from '@utils/utils';
import { useMutation } from '@apollo/client';
import { ADD_USER_DEPOSIT } from '@graphql/Mutations';

interface ICalculatorState {
  duelpoints: number;
  solana: number;
}

const Deposit = (): JSX.Element => {
  const [{ userData: user }, setData] = useReduxState((state) => state);
  const [{ duelpoints, solana }, setCalculator] = useState<ICalculatorState>({
    duelpoints: 0,
    solana: 0,
  });
  const [playReadySound] = useSound(readyAudio, { interrupt: true });
  const [playErrorSound] = useSound(errorAudio, { interrupt: true });

  const [addDeposit] = useMutation(ADD_USER_DEPOSIT);

  const onChange = (e: ChangeEvent<HTMLInputElement>): void =>
    setCalculator((formState) => ({
      ...formState,
      solana: Math.max(0, Number(e.target.value)),
    }));

  const handleDeposit = async (): Promise<void> => {
    console.log('Hey');

    const wallet = await ConnectWallet();
    await wallet!.connect();

    console.log(wallet);
    if (!user) {
      console.log('noupe');
    }
    try {
      // eslint-disable-next-line no-undef
      const connection = new Connection(process.env.REACT_APP_SOLANA_RPC as string);
      // eslint-disable-next-line no-undef
      const toWallet = new PublicKey(process.env.REACT_APP_DUELANA_WALLET as string);
      const transaction = new Transaction().add(
        SystemProgram.transfer({
          fromPubkey: wallet!.publicKey!,
          toPubkey: toWallet,
          lamports: solana * LAMPORTS_PER_SOL,
        })
      );
      const signature = await wallet!.sendTransaction(transaction, connection);
      await connection.confirmTransaction(signature, 'singleGossip');

      if (signature) {
        const deposit = await addDeposit({
          variables: {
            signature,
            userId: user.id,
          },
        }).then((result) => {
          if (result.errors) toastErrorMessage('Error adding deposit');
          if (result.data) return result.data;
        });

        if (deposit) {
          setData({
            type: 'USER_UPDATE_BALANCE',
            arg: {
              balance: deposit.addUserDeposit.points_equivalent,
              type: 'add',
            },
          });
          toastSuccessMessage(`Added ${deposit.addUserDeposit.points_equivalent} chips to your account`);
          playReadySound();
        }
      }
    } catch (err: any) {
      console.log(err);
      toastErrorMessage(`Transaction couldn't be processed`);
      playErrorSound();
    }
  };

  useEffect(() => {
    const duelpoints = solana > 0 ? +(convertSOLtoDuelanaPoints(solana) * LAMPORTS_PER_SOL).toFixed(5) : 0;
    setCalculator((prevState) => ({ ...prevState, duelpoints }));
  }, [solana]);

  /* ClassNames */

  const inputsClasses = cn(styles.body__inputs, styles.deposit);

  return (
    <div className={styles.transference}>
      <section className={styles.head}>
        <div>
          <h3>
            <SolanaIcon />
            Deposit with <span>Solana</span>
          </h3>
          <p>1 SOL = $154.99 USD</p>
        </div>
        <Button color='dark-lighten' radius='normal' className={styles.head__history}>
          History
        </Button>
      </section>
      <section className={styles.body}>
        <h4>Value Calculator*</h4>
        <div className={inputsClasses}>
          <Input type='number' value={solana === 0 ? '' : solana.toString()} onChange={onChange} icon={<SolanaNoBgIcon />} name='solana' placeholder='Enter Solana Amount' />
          <p className={styles.body__equal}>=</p>
          <Input type='number' value={duelpoints === 0 ? '' : duelpoints.toString()} readOnly icon={<CoinIcon />} name='duelpoints' placeholder='Enter Coins Amount' />
        </div>
        <p className={styles.body__disclaimer}>*The value of Solana may vary between now and the time we receive your payment</p>
      </section>
      <Button color='green' size='normal' radius='pill' className={styles.submit} onClick={handleDeposit}>
        Deposit
      </Button>
      <section className={styles.footer}>
        <Button color='dark-lighten' radius='normal'>
          History
        </Button>
        <Button color='dark-lighten' radius='normal'>
          Coupon
        </Button>
      </section>
    </div>
  );
};
export default Deposit;
